import styled from 'styled-components';

interface WrapperProps {
  $desktop?: boolean;
  $mobile?: boolean;
}

interface PrevNextPlanProps {
  $prev?: boolean;
  $next?: boolean;
  $hide?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: auto;
  padding: 6px;
  border-radius: 4px;
  background: var(--Primary-50, #ECF3F6);
  will-change: transform;

  ${({ theme }) => theme.min("sm")`
    ${({ $mobile }: WrapperProps) =>
      $mobile &&
      `
      display: none;
    `};
  `}
`;

export const PrevNextPlan = styled.button<PrevNextPlanProps>`
  font-family: "Poppins";
  outline: none;
  border: none;
  font-size: 14px;
  line-height: 24px;
  color: #000;
  width: 28px;
  height: 28px;
  background: #D0E3ED;
  border-radius: 3px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  will-change: transform;

  ${({ theme }) => theme.max("sm")`
    padding: 0;
  `}

  img {
    width: 12px;
    height: 12px;

    ${({ $prev }) => $prev &&`
      transform: rotate(180deg);
    `};
  }

  &:hover {
    img {
      ${({ $prev }) => $prev &&`
        transform: rotate(180deg) ;
      `};
    }
  }
`;

export const PageCount = styled.span`
  font-family: "Poppins";
  font-size: 16px;
  line-height: 24px;
  margin: 0 16px;
  color: #06203a;
  will-change: transform;
`;